import { render, staticRenderFns } from "./exhibition-template.vue?vue&type=template&id=28afcd77&scoped=true&"
import script from "./exhibition-template.vue?vue&type=script&lang=js&"
export * from "./exhibition-template.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template.vue?vue&type=style&index=0&id=28afcd77&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28afcd77",
  null
  
)

export default component.exports